import Moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ButtonLoader from '../../Elements/Button/button';
import ThumbnailGrid from '../../Elements/Thumbnail/thumbnail';
import InComponentLoader from '../../Elements/Loader/componentloader';
import '../../../assets/css/siicex-usuario.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import React, { Component } from 'react';
import axios from 'axios';
import {API_URL,BASE_URL_CMS,BASE_URL_RECURSOS,BASE_URL_FRONTEND} from '../../../constants';
import Error from '../../Error/error';
import {stateToHTML} from 'draft-js-export-html';
import {DropDownList} from '../../Elements/Select/dropdown';
import Select from 'react-select';
import {DropDownListChild} from '../../Elements/Select/dropdown';
import cookie from 'react-cookies';
import ImageUploader from 'react-images-upload';
import PdfFirstPagePreview from '../../Elements/PdfPreview/pdf-preview';
import {hasSpecificRole, toBase64} from '../../../functions';
import {updateValueInJson, showModalPageClass, hideModalPageClass} from '../../../functions';
import { Link } from 'react-router-dom';
import {  EditorState } from 'draft-js';
import {ValidateState} from '../../../functions';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import BulletinIcon from '@material-ui/icons/EventNote';
import ContenidoIcon from '@material-ui/icons/LineStyle';
import ImagenIcon from '@material-ui/icons/Image';
import VideoIcon from '@material-ui/icons/VideoLibrary';
import InfoIcon from '@material-ui/icons/HelpOutline';
import DocumentIcon from '@material-ui/icons/AttachFile';
import { DropDownListMaster } from '../../Elements/Select/dropdownChild';
import { DropDownListChildMaster } from '../../Elements/Select/dropdownChild';
import Checkbox from '@material-ui/core/Checkbox';
import ReactPlayer from 'react-player'
import CKEditor from 'ckeditor4-react';
import ModalMultimedia from '../../Partials/ModalMultimedia';
import TagInput from '../../Elements/TagInput/TagInput';
import { validateImageFile, fetchImageDimensions, fetchImagePesoMaximo , callCambiaEstado, cargarConfiguracionRoles, getCKEditorConfig} from './utils';
import {BotoneraCrud, BotoneraEstados, navegarTab} from './Botonera';
import { useUnsavedChanges } from '../../Root/UnsavedChangesContext';

function TabPanel(props) {
    const { children, value, index } = props;

    return (
        <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-prevent-tabpanel-${index}`}
        aria-labelledby={`scrollable-prevent-tab-${index}`}>
        <Box p={3}>{children}</Box>
      </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
};

let countCaracteresResumenPdf = 0;
const LIMITE_CARACTERES_RESUMEN = 3000;

class add_recurso extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nNumero: '',
            listCategorias: [],
            resource:{},
            response: [],
            error: [],
            sectors: [],
            key: 0,
            editorState: EditorState.createEmpty(),
            editorStateHTML : '' ,
            editorStateB: EditorState.createEmpty(),
            editorStateHTMLB : '' ,
            security: cookie.load('user'),
            roles: [],
            numeroTab: 0,
            HTML: '<span>&nbsp</span>',
            fieldReturnMultimedia:"",
            imagesToSelect: false,
            selectedImage: false,
            selectedFile: false,
            imageLimitDimension: null,
            imageDimensionError: '',
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.handleInputChangeDate = this.handleInputChangeDate.bind(this);
        this.onEditorChangeEdit = this.onEditorChangeEdit.bind(this);
        this.onEditorChangeEditResumen = this.onEditorChangeEditResumen.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.asignDefaultImage = this.asignDefaultImage.bind(this);
        this.getResponse = this.getResponse.bind(this);
        this.handleProductoChange = this.handleProductoChange.bind(this);

        this.currentImagePage = 1;

        this.VALIDAR_IMAGEN_AL_GRABAR = true;
    }

    onEditorChangeEdit(evt) {
        if (evt.editor !== undefined){
          let html = evt.editor.getData();
          let copyResource = JSON.parse(JSON.stringify(this.state.resource));
          copyResource["sContenido"] = html;
          this.setState({
            resource: copyResource,
            HTML: html
          }, ()=> {});
        }
    }

    onEditorChangeEditResumen(evt, campo="") {
        let html = evt.editor.getData();
        let caracteres = html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').replace(/&\w+;/g ,'X').replace(/^\s*/g, '').replace(/\s*$/g, '').length;

        if (caracteres > LIMITE_CARACTERES_RESUMEN) {
            // Se excedió el límite: se revierte el editor al último contenido válido en vez de aceptar el exceso.
            // Cubre tipeo, pegado, arrastrar-y-soltar y deshacer/rehacer, ya que todos disparan este mismo evento 'change'.
            if (this._revirtiendoResumen) { return; } // evita reentrancia por el propio setData() de abajo
            this._revirtiendoResumen = true;
            toast.warn(`El resumen alcanzó el límite de ${LIMITE_CARACTERES_RESUMEN} caracteres.`);
            evt.editor.setData(this.state.resource["recu_ResumenPdf"] || '', {
                callback: () => { this._revirtiendoResumen = false; }
            });
            return;
        }

        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource["recu_ResumenPdf"] = html;
        document.getElementById("count-caracteres-" + campo).innerHTML = caracteres;
        countCaracteresResumenPdf = caracteres;

        this.setState({
            resource: copyResource
        });
    }

    GetSectors(){
        const urlBase  = `${API_URL}`
        axios.get(urlBase + 'MasterUX/6').then(response => response.data)
        .then((data) => {
            this.setState({ sectors: data.result});
        }).catch(error => {
        });
    }

    handleChangeTab = (event, newValue) => {
        this.setState({numeroTab: newValue});
    };


    handleInputChange(event){
        if (event && typeof event.persist === 'function') event.persist();

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        if(event.target.id === "sArchivoNombre"){
            let texto = event.target.value.toLocaleLowerCase();
            let textoOri = event.target.value;
            let letras = "abcdefghijklmnopqrstuvwxyz0123456789-.";
            let _valueO = '';

            for (var i = 0; i < texto.length; i++) {
              if (letras.indexOf(texto[i]) != -1) {
                _valueO += textoOri[i];
              }
            }

            event.target.value = _valueO;
            copyResource['sArchivoNombre'] = _valueO;
        }
        else if(event.target.id === "recu_SeoUrlCanonical"){
            let texto = event.target.value.toLocaleLowerCase();
            let textoOri = event.target.value;
            let letras = "abcdefghijklmnopqrstuvwxyz0123456789-";
            let _valueO = '';

            for (var i = 0; i < texto.length; i++) {
              if (letras.indexOf(texto[i]) != -1) {
                _valueO += textoOri[i];
              }
            }

            event.target.value = _valueO;
            copyResource['recu_SeoUrlCanonical'] = _valueO;
        }
        else if(event.target.id === "sTitulo"){
            let textoOriginal = event.target.value;
            let regexCaracterValido = /[a-zA-Z0-9À-ÿÑñ ]/;
            let _valueTitulo = '';

            for (var j = 0; j < textoOriginal.length; j++) {
              if (regexCaracterValido.test(textoOriginal[j])) {
                _valueTitulo += textoOriginal[j];
              }
            }

            event.target.value = _valueTitulo;
            copyResource['sTitulo'] = _valueTitulo;
        }
        else{
           copyResource[target.name] = value;
        }

        if(target.name === 'sOrigen'){
            const sOrigenTexto = (value && typeof value === 'object') ? (value.value || '') : (value || '');
            if(sOrigenTexto.toString().trim().toUpperCase() !== 'PROMPERÚ'){
                copyResource['sAutor'] = '';
            }
        }

        if(event.target.id == "sTitulo"){
            let _value = event.target.value.toLocaleLowerCase();

            const mapaLimpieza = [  
                {val: " ", replace: "-"},
                {val: "á", replace: "a"}, {val: "é", replace: "e"}, {val: "í", replace: "i"},
                {val: "ó", replace: "o"}, {val: "ú", replace: "u"},
                {val: "ñ", replace: "n"}, {val: "ü", replace: "u"}  
            ];
            mapaLimpieza.forEach((item) => {
                while(_value.indexOf(item.val) !== -1) { _value = _value.replace(item.val, item.replace);}
            });
            _value = _value.replace(/[^a-z0-9\-]/g, '').replace(/-+/g, '-');         

            copyResource['sUrlCanonical'] = _value;
            copyResource['sArchivoNombre'] = _value;
            
        }

        this.setState({ resource: copyResource }, () => {
            console.log("ESTADO: sUrlCanonical", this.state.resource.sUrlCanonical )
        });

    }

    changeTagInput(name, val){
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource[name] = val;
        this.setState({ resource: copyResource }, () => console.log(this.state.resource));
    }

handleProductoChange(event) {
        const selectedOptions = event.target.value;
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        let productoDescriptions = null;
        if (selectedOptions && selectedOptions.length > 0) {
            productoDescriptions = selectedOptions.map(option => option.label).join(',');
        }

        copyResource['sProducto'] = productoDescriptions;
        this.setState({ resource: copyResource });
    }

    loadCategoriasManual = (idTipo) => {
        const id = (idTipo && typeof idTipo === 'object') ? idTipo.value : idTipo;
        if (!id || id === 0 || id === "0") {
            this.setState({ listCategorias: [] });
            return;
        }
        axios.get(`${API_URL}CategoryUX/${id}`)
            .then(res => {
                this.setState({ listCategorias: res.data.result || [] });
            })
            .catch(err => console.error("Error al cargar categorías:", err));
    }

    async componentDidMount(){
        await fetchImageDimensions().then(limits => {this.setState({ imageLimitDimension: limits });});
        await fetchImagePesoMaximo().then(maxMB => {this.setState({ imageLimitePesoBytes: maxMB * 1024 * 1024 });});

        await this.GetSectors();
        await this.getImages();

        var key = this.props.location.state.key ;
        const url = `${API_URL}ResourceUX/${key||"0"}/1`;
        var roles = [];
        roles = this.state.security.cRolesxUsuario.length > 0 ? this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; }) : [];
        axios.get(url).then(response => response.data)
        .then((data) => {
            let copyResource = JSON.parse(JSON.stringify(data.result));
            copyResource["cEstado"] = { value: "R", label: "Borrador" }; // Agregamos label por seguridad
            copyResource["nAprobador"] = { value: 0, label: "Seleccionar Aprobador" };
            copyResource["bActivo"] = true;
            copyResource["bActivo"] = true;
            copyResource["recu_NotificarPorPush"] = false;
            copyResource["recu_NotificarPorCorreo"] = false;
            copyResource["recu_SeoSeguirEnlace"] = false;
            copyResource["recu_SeoMostrarMotores"] = false;
            copyResource["nUbicacionCodigo"] = 1;
            copyResource["Recu_PalabrasClave"] = '';
            copyResource["nTipoRecursoCodigo"] = 15;

            this.setState({
                roles: roles,
                resource: copyResource,
                response: data,
                error: data.Error,
                numeroTab: 0
            }, () => {
                // Snapshot para detectar cambios sin guardar (¿Quieres guardar los cambios antes de salir?)
                this.initialResourceSnapshot = JSON.stringify(this.state.resource);
            });

            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");

            this.loadCategoriasManual(15);
        })
        .catch(error => {
            document.querySelector('.loader').classList.add('loader--hide');
            toast.error("¡Error al consultar items [add-recurso]!");
        });
        await cargarConfiguracionRoles();

        // Registrar en el Context: cómo saber si hay cambios sin guardar, y cómo guardar.
        if (this.props.registerFormGuard) {
            this.props.registerFormGuard(this.hasUnsavedChanges, this.saveForExit);
        }
    }

    componentWillUnmount(){
        if (this.props.clearFormGuard) {
            this.props.clearFormGuard();
        }
    }

    // Compara el resource actual contra el snapshot tomado al cargar la pantalla.
    hasUnsavedChanges = () => {
        if (!this.initialResourceSnapshot) return false;
        return JSON.stringify(this.state.resource) !== this.initialResourceSnapshot;
    }

    // Guarda como "Borrador"/estado actual (mismo comportamiento que el botón Guardar existente)
    // y, solo si el guardado fue exitoso, ejecuta onSuccess (la navegación pendiente: logout/home).
    saveForExit = (onSuccess) => {
        const letra = (this.state.resource.cEstado && this.state.resource.cEstado.value) || "R";
        const valorAccion = letra === "R" ? "Borrador" : "GrabarCerrar";
        callCambiaEstado(this, null, valorAccion, "", "", onSuccess);
    }

    handleClickCancel(e){
        const { requestNavigation, history } = this.props;
        const goTo = () => history.push({ pathname: '/recurso' });
        if (requestNavigation) {
            requestNavigation(goTo);
        } else {
            goTo();
        }
    }

    // Mismo patrón que Header.js/handleLogoClick: intercepta la navegación de los enlaces
    // del breadcrumb (Panel de Configuración General, Recursos) si hay cambios sin guardar,
    // mostrando el modal de confirmación en vez de navegar directo.
    handleBreadcrumbClick = (e, pathname) => {
        e.preventDefault();
        const { requestNavigation, history } = this.props;
        const goTo = () => history.push({ pathname });
        if (requestNavigation) {
            requestNavigation(goTo);
        } else {
            goTo();
        }
    }

    async asignDefaultImage (codigo){
        const url = `${API_URL}CategoryUX/ObtenerCategoriaRecurso/${codigo}`;
        try{
            const res = await axios.get(url);
            if(res.data.result){
                const result = res.data.result;
                const defaultImg = result.imagenPorDefecto;
                this.state.resource.sImagen = defaultImg;
            }
        } catch(err){
            this.state.resource.sImagen = "";
        }
        
    }

    validarFormularioCompleto = () => {
        let _isOk = true;
        const r = this.state.resource;
        if (ValidateState(r, 'sTitulo', '')) {  toast.error('Ingrese un título'); _isOk = false; }
        if (ValidateState(r, 'cRec_Id', '0')) { toast.error('Seleccione la temática'); _isOk = false; }

        const formatoVal = r.nFormato?.value ?? r.nFormato;
        if (!formatoVal || formatoVal == 0 || formatoVal == "0") { toast.error('Seleccione el formato del documento'); _isOk = false; }

        const fechaVal = r.dFechaPublicacion;
        if (!fechaVal || fechaVal.toString().trim() === '') { toast.error('Seleccione la fecha del documento'); _isOk = false; }

        const sOrigenTexto = (r.sOrigen && typeof r.sOrigen === 'object') ? (r.sOrigen.value || '') : (r.sOrigen || '');
        if (!sOrigenTexto || sOrigenTexto.toString().trim() === '') { toast.error('Seleccione el autor del documento'); _isOk = false; }

        const enlace = r.sEnlaceDocumento;
        if (!enlace || enlace.trim() === '') { toast.error('Adjunte un documento'); _isOk = false; }

        if (!r.nAprobador || r.nAprobador.value === 0 || r.nAprobador === 0) { 
            toast.error('Debe seleccionar un Aprobador'); 
            _isOk = false; 
        }

        return _isOk;
    };

    // #save #guardar #grabar
    callFunctionButton = async (event, letraPropuesta = null, motivoRechazo = "", modoCRUD = "", estadoAnterior = null, onSuccessCallback = null) => {
            if (event) {
                if (typeof event.persist === 'function') event.persist();
                event.preventDefault();
            }

            const { history } = this.props;
            let _isOk = true;

            if (this.VALIDAR_IMAGEN_AL_GRABAR && this.state.selectedImage) {
                const val = await validateImageFile(
                    this.state.selectedImage,
                    this.state.imageLimitDimension,
                    this.state.imageLimitePesoBytes
                );

                if (!val.ok) {
                    toast.error(val.message);
                    this.setState({ loading: false });
                    return;
                }
            }

            let tipoRecurso = this.state.resource.nTipoRecursoCodigo;

            if(ValidateState(this.state.resource, 'nTipoRecursoCodigo', '0')){  toast.error('Error en Validación: Seleccione al menos un Tipo de Recurso.'); _isOk = false; }
            if(ValidateState(this.state.resource, 'cRec_Id', '0')){  toast.error('Error en Validación: Seleccione al menos una Temática de Recurso.'); _isOk = false; }
            if(ValidateState(this.state.resource, 'sTitulo', '')){  toast.error('Error en Validación: Ingrese un Título.'); _isOk = false;  }
            
            let estadoCalculado = letraPropuesta || (this.state.resource.cEstado?.value || this.state.resource.cEstado || "R");
            const nAprobadorVal = this.state.resource.nAprobador?.value ?? this.state.resource.nAprobador;
            if (estadoCalculado === "X") {
                if (!nAprobadorVal || nAprobadorVal == 0 || nAprobadorVal == "0") {
                    toast.error('Para solicitar la aprobación, seleccione un aprobador');
                    _isOk = false;
                }
            }

            if(tipoRecurso && (tipoRecurso.value == 14 || tipoRecurso == 14)){
                if(ValidateState(this.state.resource, 'sResumen', '')){  toast.error('Error en Validación: Ingrese un Resumen.'); _isOk = false; }
            }

            if(typeof countCaracteresResumenPdf !== 'undefined' && countCaracteresResumenPdf > LIMITE_CARACTERES_RESUMEN){
                toast.error(`Error en Validación: Resumen del PDF supera el límite de los ${LIMITE_CARACTERES_RESUMEN} caracteres.`); 
                _isOk = false;
            }

            if (!this.state.resource.sImagen || this.state.resource.sImagen === "") {
                let typeCode = this.state.resource.nTipoRecursoCodigo.value
                            ? this.state.resource.nTipoRecursoCodigo.value
                            : this.state.resource.nTipoRecursoCodigo;
                await this.asignDefaultImage(typeCode);
            }

            if(!_isOk){
                this.setState({ loading: false });  
                return;
            }

            const url = `${API_URL}ResourceUX/`;
            var dataForm = JSON.parse(JSON.stringify(this.state.resource));

            this.setState({loading:true});

            var sAutor    = this.state.resource.sAutor || {};
            var sOrigen   = this.state.resource.sOrigen || {};
            var nUbicacionCodigo    = this.state.resource.nUbicacionCodigo || [];
            var nSectorCodigo       = this.state.resource.nSectorCodigo || [];
            var listPartida         = this.state.resource.listPartida || [];
            var listLineaProducto   = this.state.resource.listLineaProducto || [];
            var sProducto           = this.state.resource.sProducto;

            var ubicacion = Array.isArray(nUbicacionCodigo) ? nUbicacionCodigo.map(v => v.value ?? v) : [];
            var sector              = nSectorCodigo.map(v => v.value);
            var partida             = listPartida ? listPartida.map(v => v.value) : [];
            var sectorNames         = nSectorCodigo.map(v => v.label);
            var lineaProducto       = listLineaProducto ? listLineaProducto.map(v => v.value) : [];

            dataForm.listLineaProducto = String(lineaProducto);
            dataForm.nUsuarioCreacion = this.state.security.nUsuCodigo;
            dataForm.listPais = String(ubicacion);
            dataForm.listSector = String(sector);
            dataForm.listPartida = String(partida);
            dataForm.sAutor = sAutor.value ? sAutor.value : (typeof sAutor === 'string' ? sAutor : '');
            dataForm.sOrigen = sOrigen.value ? sOrigen.value : (typeof sOrigen === 'string' ? sOrigen : '');
            dataForm.sProducto = sProducto ? sProducto : '';
            dataForm.nLineaProductoCodigo = 0;
            dataForm.nUbicacionCodigo = 0;
            dataForm.nLineaProductoCodigo = 0;
            dataForm.nUbicacionCodigo = 0;
            dataForm.nSectorCodigo = 0;
            
            if (estadoCalculado === "P" || estadoCalculado === "O") { estadoCalculado = "X"; }
            
            dataForm.cEstado = estadoCalculado;
            dataForm.sComentario = motivoRechazo || "";
            dataForm.sRolCRUD = this.state.resource.sRolCRUD || "";
            dataForm.sAccionCRUD = modoCRUD || "";
            
            dataForm.nTipoRecursoCodigo = (this.state.resource.nTipoRecursoCodigo.value ? this.state.resource.nTipoRecursoCodigo.value : this.state.resource.nTipoRecursoCodigo);

            const aprobadorRaw = this.state.resource.nAprobador?.value ?? this.state.resource.nAprobador;
            dataForm.nAprobador = parseInt(aprobadorRaw || 0, 10);

            const formatoRaw = this.state.resource.nFormato?.value ?? this.state.resource.nFormato;
            dataForm.nFormato = parseInt(formatoRaw || 0, 10);

            dataForm.sSector = String(sectorNames);
            dataForm.bActivo = true;

            dataForm.recu_NotificarPorPush = !!(this.state.resource.recu_NotificarPorPush?.value ?? this.state.resource.recu_NotificarPorPush);
            dataForm.recu_NotificarPorCorreo = !!(this.state.resource.recu_NotificarPorCorreo?.value ?? this.state.resource.recu_NotificarPorCorreo);
            dataForm.recu_SeoSeguirEnlace = !!(this.state.resource.recu_SeoSeguirEnlace?.value ?? this.state.resource.recu_SeoSeguirEnlace);
            dataForm.recu_SeoMostrarMotores = !!(this.state.resource.recu_SeoMostrarMotores?.value ?? this.state.resource.recu_SeoMostrarMotores);
            
            dataForm.cRec_Id = (this.state.resource.cRec_Id?.value || this.state.resource.cRec_Id);
            dataForm.sUsuario = this.state.security.sUsuNombre + ' ' + this.state.security.sUsuApellidoPaterno;

            // Validaciones preGuardar
            if ( !(dataForm.cEstado == "R" || dataForm.cEstado == "I") && ( dataForm.nAprobador == 0 || dataForm.nAprobador == "0") ) {
                toast.error('Error: Debe seleccionar un Aprobador');
                this.setState({ loading: false });
                return;
            }

            // Validaciones preGuardar:End

            const formData = JSON.stringify(dataForm);
            axios.post(url, JSON.stringify(formData),
                {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                    }
                }
            ).then( data => {
                if (data.data.isSucess && data.data.result){
                    if (onSuccessCallback) {
                        // Viene del flujo "Guardar y salir": el guardado fue exitoso,
                        // se continúa con la acción original (logout / ir al home) en vez de navegar al listado.
                        toast.success('Recurso registrado correctamente.');
                        setTimeout(() => { onSuccessCallback(); }, 1000);
                    } else {
                        toast.success('Recurso registrado correctamente.');
                        setTimeout(() => {
                            if (history) { history.push('/recurso'); } else { window.location.href = "/recurso"; }
                        }, 1000);
                    }
                } else {
                    this.setState(prevState => ({
                        loading: false,
                        resource: estadoAnterior ? {
                            ...prevState.resource,
                            cEstado: estadoAnterior.cEstado,
                            sEstado: estadoAnterior.sEstado,
                        } : prevState.resource,
                    }));
                    toast.error(data.data.statusMessage || 'No se pudo registrar el Recurso.');
                }
            }).catch((error)=> {
                console.error(error);
                toast.error('Error de red al intentar guardar.');
                this.setState({loading:false});
            });
        }

    onEditorStateChange = (event) => {
        let html = event.editor.getData();
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        copyResource["sContenido"] = html;

        this.setState({
            resource: copyResource
        });
    };

    handleInputChangeDate(control){
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource['dFechaPublicacion'] = Moment(control).format('YYYY-MM-DD') + Moment().format('[T]HH:mm:ss.SSS');
         this.setState({resource: copyResource});
    }

    // La librería ImageUploader rechaza archivos con extensión/tamaño inválido
    // de forma interna, sin llegar a invocar onDrop (solo actualiza su propio
    // estado fileErrors). Por eso el error de dimensión de un intento anterior
    // (imageDimensionError) puede quedar pegado en pantalla junto al nuevo
    // mensaje de la librería. Se limpia acá, al primer clic sobre el selector,
    // en vez de depender de que onDrop se ejecute.
    clearImageDimensionError = () => {
        if (this.state.imageDimensionError) {
            this.setState({ imageDimensionError: '' });
        }
    }

    onDrop = async (file_container, flag) => {
        if (file_container.length < 1) return;

        const file = file_container[0];
        if (!file) {
            this.setState({ [flag]: false });
            return;
        }

        if (flag === 'selectedImage') {
            const result = await validateImageFile(
                file,
                this.state.imageLimitDimension,
                this.state.imageLimitePesoBytes
            );

            if (!result.ok) {
                toast.error(result.message);
                this.setState({ selectedImage: false, imageDimensionError: result.message });
                return;
            }

            this.setState({ imageDimensionError: '' });
        }

        toBase64(file).catch(e => {
            if (flag === 'selectedImage') {
                toast.error("Ocurrió un error al analizar la imagen, por favor seleccione otra");
            } else {
                toast.error("Ocurrió un error al analizar el archivo, por favor seleccione otro");
            }
            this.setState({ [flag]: false });
        }).then(data => {
            let _tmp = {};
            _tmp[flag] = file;
            _tmp[flag].base64 = data;
            this.setState(_tmp);
        });
    }


    useStyles = makeStyles(theme => ({
        root: {
          flexGrow: 1,
          backgroundColor: theme.palette.background.paper,
        },
    }));

    getImages(page=1){
      const urlBase  = `${API_URL}`
      axios.get(urlBase + `FileUX/0/${page}/all/all/all`).then(response => response.data)
      .then((data) => {
        this.currentImagePage = page
        this.setState({ imagesToSelect: data.result});
      }).catch(error => {
        console.error(error);
      });
    }


    selectImage = (img_obj) => {
      // Set this.state properties
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sImagen', img_obj.sArchivoRuta)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', img_obj.nArchivoCodigo)
      this.setState({resource: _tmp}, () => {
        document.getElementById("thumbnail-modal-close").click();
      });
    }

    unSelectImage = () => {
        let _tmp = updateValueInJson(this.state.resource, 'sImagen', "");
        _tmp = updateValueInJson(_tmp, 'nImagenCodigo', 0);
        this.setState({ 
            resource: _tmp,
            selectedImage: false, 
            uploaderKey: Date.now(),
            imageDimensionError: ''
        });
    }

    unSelectDoc = () => {
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sEnlaceDocumento', "")
      _tmp = updateValueInJson(_tmp, 'nArchivoCodigo', 0)
      _tmp = updateValueInJson(_tmp, 'sArchivoNombreOld', "")
      this.setState({resource: _tmp, selectedFile: false});
    }

    uploadImage = async () => {
        let _file = this.state.selectedImage;

        if (!_file) {
            toast.error("No hay ninguna imagen seleccionada para subir.");
            return;
        }

        const r = await validateImageFile(
            _file,
            this.state.imageLimitDimension,
            this.state.imageLimitePesoBytes
        );

        if (!r.ok) {
            toast.error(r.message);
            return;
        }

        let formData = {};
        let _filename = _file.name;

        formData.sArchivoNombre = _filename;
        formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16";
        formData.sArchivoExtension = _filename.substring(_filename.lastIndexOf(".") + 1, _filename.length);
        formData.sArchivoTipo = "imagenes";
        formData.sCategoriaArchivo = "";
        formData.sArchivoData = _file.base64;
        formData.nCodigoUsuario = this.state.security.nUsuCodigo;

        toast.info("Espere mientras la imagen es procesada");

        axios.post((API_URL + `FileUX/`),
            ("'" + JSON.stringify(formData) + "'"),
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Accept': 'application/json'
                }
            }
        ).then(data => {
            toast.success("La imagen ha sido subida correctamente");

            let _tmp = updateValueInJson({}, 'sImagen', data.data.result.sArchivoRuta);
            _tmp = updateValueInJson(_tmp, 'nImagenCodigo', data.data.result.nArchivoCodigo);

            this.setState({ resource: { ...this.state.resource, ..._tmp } });
        }).catch((error) => {
            console.error(error);
            toast.error('Error al subir la imagen');
        });
    }


  uploadFile = async () => {

    if (!this.state.resource.sTitulo || this.state.resource.sTitulo.trim() === '') {
        toast.error('Debe ingresar primero el título del documento en el Tab General antes de subir el archivo.');
        return;
    }

    let _file = this.state.selectedFile;

    if (!_file) {
        toast.error("Debe seleccionar un archivo PDF.");
        return;
    }

    let formData = {};
    let _filename = _file.name;

    formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16";
    formData.sArchivoExtension = _filename.substring(_filename.lastIndexOf(".") + 1, _filename.length);
    // sArchivoNombre puede venir ya con extensión de una subida previa (el backend la devuelve incluida
    // y ese valor se guarda en el estado). Se quita antes de concatenar para no duplicarla.
    let _sArchivoNombreSinExtension = this.state.resource.sArchivoNombre.replace(/(\.[^./\\]+)+$/, '');
    formData.sArchivoNombre = `${_sArchivoNombreSinExtension}.${formData.sArchivoExtension}`;
    formData.sArchivoTipo = "documentos";
    formData.sCategoriaArchivo = "";
    formData.sArchivoData = _file.base64;
    formData.nCodigoUsuario = this.state.security.nUsuCodigo;

    toast.info("Espere mientras el documento es procesado, esto puede tomar hasta un minuto...");

    axios.post((API_URL + `FileUX/`),
        ("'" + JSON.stringify(formData) + "'"),
        {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': 'application/json'
            }
        }
    ).then(data => {
        if (!data.data || !data.data.isSucess || !data.data.result) {
            console.error('Respuesta sin éxito al subir el documento:', data.data);
            toast.error(
                (data.data && data.data.statusMessage) ||
                'No se pudo subir el documento. Verifique el tamaño/formato e intente nuevamente.'
            );
            return;
        }

        toast.success("El documento ha sido subido correctamente");

        let _tmp = updateValueInJson({}, 'nArchivoCodigo', data.data.result.nArchivoCodigo);
        _tmp = updateValueInJson(_tmp, 'sEnlaceDocumento', data.data.result.sArchivoRuta);
        _tmp = updateValueInJson(_tmp, 'sArchivoNombre', data.data.result.sArchivoNombre);
        _tmp = updateValueInJson(_tmp, 'sArchivoNombreOld', data.data.result.sArchivoNombre);

        this.setState({ resource: { ...this.state.resource, ..._tmp } });
    }).catch((error) => {
        console.error(error);
        toast.error('Error al subir el archivo');
    });
}

    paginationTable(){
      // Get data
      let data = this.state.imagesToSelect.length!=0 ? this.state.imagesToSelect : false;
      if(!data){
        data = this.state.imagesToSelect;
        if(!data || data.length==0) return;
      }

      // Pagination calcs
      let totalPages = data[0].totalPages;
      let options = false;
      options = [];

      // Inicio button
      if(totalPages>2) options.push(<span id={"pagination-inicio"} key={"pagination-inicio"} onClick={() => this.getImages(1)}>Inicio </span>);
      // Index buttons
      for(let index=1; index<(totalPages+1); index++){
        if(index>10 && index%10!=0) continue;
        options.push(
          <span id={"pagination-"+index}
            key={"pagination-link-"+index}
            onClick={() => this.getImages(index)}
            className={index===this.currentImagePage?"active":""}>
              {index}
          </span>
        );
      }
      // Fin button
      if(totalPages>2) options.push(<span id={"pagination-fin"} key={"pagination-fin"} onClick={() => this.getImages(totalPages)}>Fin </span>);

      return (
        <div className="pagination" key={"pagination"}>
          {options}
        </div>
      );
    }

    letrasNumeroBlur = (e) => {
        let texto = e.target.value.toLowerCase();
        let textoOri = e.target.value;
        let result = "";
        let letras = "abcdefghijklmnñopqrstuvwxyz0123456789-.";

        for (var i = 0; i < texto.length; i++) {
          if (letras.indexOf(texto[i]) != -1) {
            result += textoOri[i];
          }
        }
        e.target.value = result;
        this.handleInputChange(e);
    }

    letrasCanonicalBlur = (e) => {
        let texto = e.target.value.toLowerCase();
        let textoOri = e.target.value;
        let result = "";
        let letras = "abcdefghijklmnopqrstuvwxyz0123456789-";

        for (var i = 0; i < texto.length; i++) {
          if (letras.indexOf(texto[i]) != -1) {
            result += textoOri[i];
          }
        }
        e.target.value = result;
        this.handleInputChange(e);
    }

    getResponse = (urlSeleccionada) => {
        let resource = this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;

        if(fieldReturn!== ""){

            resource[fieldReturn] = urlSeleccionada;

            this.setState({resource:resource, fieldReturnMultimedia:""});
        }

        hideModalPageClass("divGestorArchivosMultimedia");
    }

    showModalMultimedia = (clase = "", campo="") => {
        this.setState({fieldReturnMultimedia:campo});
        showModalPageClass(clase);
    }


    render() {

        const userCookie = this.state.security || {};
        const isSuperAdmin = userCookie.Tusu_EsSuperAdmin === true || userCookie.Tusu_EsSuperAdmin === "true";
        const currentCKEditorConfig = getCKEditorConfig(isSuperAdmin);

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });
        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        const { editorState } = this.state;
        //console.log(this.state);


        return (
                (this.state.response.statusCode === 200) ?
                (
                    <div id="detailBody" className="Site-content" >
                        <div className="loader"></div>
                        <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} >
                            <input type="hidden" id="dFechaModificacion" name="dFechaModificacion" defaultValue={this.state.resource.dFechaModificacion} />
                            <input type="hidden" id="dFechaPublicacion" name="dFechaPublicacion" defaultValue={this.state.resource.dFechaPublicacion} />
                            <input type="hidden" id="nUsuarioModificacion" name="nUsuarioModificacion" defaultValue={this.state.resource.nUsuarioModificacion} />
                            <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">
                                    <div className="divContenedorBreadcrumbs">
                                        <div className="divCenterBreadcrumbs">
                                            <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                                                <a href="/" onClick={(e) => this.handleBreadcrumbClick(e, '/')}>
                                                    / Panel de configuración general
                                                </a>
                                                <a href="/recurso" onClick={(e) => this.handleBreadcrumbClick(e, '/recurso')}>
                                                    / Recursos
                                                </a>
                                            <span> / Nuevo documento</span>
                                        </div>
                                    </div>
                                    <div className="divTitulo_Panel mb-3">
                                        Nuevo documento
                                    </div>

                                   <div className="content-option">
                                        <div className="row ">
                                            <div className="col-md-12">
                                                <AppBar position="static" color="default" >
                                                    <Tabs   value={this.state.numeroTab} onChange={this.handleChangeTab}
                                                            scrollButtons="auto"
                                                            aria-label="icon label tabs example"
                                                            variant="fullWidth"
                                                            indicatorColor="secondary"
                                                            textColor="secondary">
                                                            <Tab label="General" {...a11yProps(0)} />
                                                            <Tab label="Documento" {...a11yProps(1)} />
                                                            <Tab label="Resumen" {...a11yProps(2)} />
                                                            <Tab label="Imagen" {...a11yProps(3)} />
                                                            <Tab label="Estados" {...a11yProps(4)} />
                                                    </Tabs>
                                                </AppBar>
                                                <TabPanel value={this.state.numeroTab} index={0}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group" style={{display:'none'}} >
                                                                    <label htmlFor="nRecursoCodigo"><strong>Código</strong></label>
                                                                    <input type="text" readOnly name="nRecursoCodigo" onChange={this.handleInputChange} id="nRecursoCodigo" defaultValue={this.state.resource.nRecursoCodigo} className="form-control text-filter__form-control" placeholder="Código" />
                                                                </div>

                                                                <div className="form-group" style={{display:'none'}} >
                                                                    <label htmlFor="nTipoRecursoCodigo"><strong>Tipo</strong></label>
                                                                    <div className="col-sm-12">
                                                                        {/* <DropDownListMaster  valor={this.state.resource.nTipoRecursoCodigo} child="Categoria" name="nTipoRecursoCodigo" id="nTipoRecursoCodigo"  onChange={this.handleInputChange} clave={this.state.resource.nTipoRecursoCodigo} componente={"TipoRecurso"} /> */}
                                                                        <input type="hidden" name="nTipoRecursoCodigo" id="nTipoRecursoCodigo" 
                                                                            value={this.state.resource.nTipoRecursoCodigo || 15} 
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="sTitulo"><strong>Título (*)</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <input type="text" name="sTitulo" id="sTitulo" maxLength={1024} 
                                                                        onChange={this.handleInputChange} defaultValue={this.state.resource.sTitulo} className="form-control text-filter__form-control" placeholder="Ingrese el título del documento" />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="cRec_Id"><strong>Temática (*)</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <Select
                                                                            classNamePrefix="select"
                                                                            inputId="cRec_Id"
                                                                            name="cRec_Id"
                                                                            placeholder="Seleccione la temática"
                                                                            options={this.state.listCategorias.map(cat => ({ value: cat.crec_Id, label: cat.crec_Nombre }))}
                                                                            value={
                                                                                this.state.listCategorias
                                                                                    .filter(cat => cat.crec_Id === (this.state.resource.cRec_Id?.value || this.state.resource.cRec_Id))
                                                                                    .map(cat => ({ value: cat.crec_Id, label: cat.crec_Nombre }))[0] || null
                                                                            }
                                                                            onChange={(selected) => {
                                                                                this.handleInputChange({
                                                                                    target: { name: 'cRec_Id', value: selected ? selected.value : 0, type: 'dropdow' }
                                                                                });
                                                                            }}
                                                                            isSearchable={true}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="cRec_Id"><strong>Formato (*)</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList valor={0} isMulti={false} name="nFormato" id="nFormato"  onChange={this.handleInputChange} clave={this.state.resource.nFormato}
                                                                            componente={"RECURSO-FORMATO"}
                                                                             placeholder="Seleccione el formato" 
                                                                            ></DropDownList>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label ><strong>Fecha del documento (*)</strong></label>
                                                                    <br/>
                                                                    <div className="col-sm-12 tab-general-date">
                                                                        <DatePicker
                                                                            className="form-control text-filter__form-control_date"
                                                                            onChange={this.handleInputChangeDate}
                                                                            maxDate={new Date()}
                                                                            value={Moment(this.state.resource.dFechaPublicacion).format('DD/MM/YYYY')}/>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="sOrigen" className='h6'>
                                                                        <strong>Autor (*)</strong>
                                                                    </label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList valor={0} isMulti={false} name="sOrigen" id="sOrigen"  onChange={this.handleInputChange} clave={this.state.resource.sOrigen}
                                                                            componente={"Recurso_Organizacion"}  placeholder="Seleccione el autor" 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="sAutor" className='h6'>
                                                                        <strong>Unidad organizacional</strong>
                                                                    </label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList key={(() => {
                                                                                const origen = this.state.resource.sOrigen;
                                                                                const sOrigenTexto = (origen && typeof origen === 'object') ? (origen.value || '') : (origen || '');
                                                                                return 'sAutor-' + sOrigenTexto.toString().trim().toUpperCase();
                                                                            })()} valor={0} isMulti={false} name="sAutor" id="sAutor"  onChange={this.handleInputChange} clave={this.state.resource.sAutor}
                                                                            componente={"Recurso_OrganizacionUnidad"} placeholder="Seleccione la unidad organizacional" 
                                                                            isDisabled={(() => {
                                                                                const origen = this.state.resource.sOrigen;
                                                                                const sOrigenTexto = (origen && typeof origen === 'object') ? (origen.value || '') : (origen || '');
                                                                                return sOrigenTexto.toString().trim().toUpperCase() !== 'PROMPERÚ';
                                                                            })()}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                
                                                                <div id='div-sresumen' className="form-group ocultar">
                                                                    <label htmlFor="sResumen"><strong>Resumen</strong></label>
                                                                    <input type="text" name="sResumen" id="sResumen" onChange={this.handleInputChange} defaultValue={this.state.resource.sResumen} className="form-control text-filter__form-control" placeholder="Resumen" />
                                                                </div>
                                                                {/* <div className="form-group">
                                                                    <label htmlFor="sOrigen"><strong>Organización</strong></label>
                                                                    <input type="text" name="sOrigen" id="sOrigen" onChange={this.handleInputChange} defaultValue={this.state.resource.sOrigen} className="form-control text-filter__form-control" placeholder="Organización respectivamente" />
                                                                </div> */}

                                                                {/* <div className="form-group">
                                                                    <label htmlFor="sAutor"><strong>Unidad organizacional</strong></label>
                                                                    <input type="text" name="sAutor" id="sAutor" onChange={this.handleInputChange} defaultValue={this.state.resource.sAutor} className="form-control text-filter__form-control" placeholder="Unidad organizacional" />
                                                                </div> */}

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                            <div className="form-group">
                                                                <label htmlFor="nUbicacionCodigo"><strong>Mercado(s)</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownList
                                                                        valor={[{pais_Id:-999}]}
                                                                        isMulti={true}
                                                                        name="nUbicacionCodigo"
                                                                        id="nUbicacionCodigo"
                                                                        onChange={this.handleInputChange}
                                                                        clave={this.state.resource.lResourceCountry}
                                                                        componente={"Ubicacion"}
                                                                         placeholder="Seleccione uno o más mercados" 
                                                                    />

                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="nSectorCodigo"><strong>Sector(es)</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownList
                                                                        valorHijo={this.state.resource.lResourceLineaProducto}
                                                                        clave={this.state.resource.lResourceSector}
                                                                        valor={[{nSectorCodigo:-999}]}
                                                                        child={["LineaProducto", "PartidaCascada"]}
                                                                        name="nSectorCodigo"
                                                                        onChange={this.handleInputChange}
                                                                        id="nSectorCodigo" componente={"Sector"}
                                                                        isMulti={true} 
                                                                         placeholder="Seleccione uno o más sectores" 
                                                                        />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="listLineaProducto"><strong>Línea(s)</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownListChild
                                                                        clave={this.state.resource.listLineaProducto}
                                                                        isMultiple={true}
                                                                        name="listLineaProducto"
                                                                        onChange={this.handleInputChange}
                                                                        parent="Sector"
                                                                        id="listLineaProducto"
                                                                        componente={"LineaProducto"}
                                                                         placeholder="Seleccione una o más líneas" 
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="listPartida"><strong>Partida(s)</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownListChild
                                                                        isMultiple={true}
                                                                        name="listPartida"
                                                                        onChange={this.handleInputChange}
                                                                        parent="Sector"
                                                                        id="listPartida"
                                                                        componente={"PartidaCascada"}
                                                                         placeholder="Seleccione una o más partidas" 
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="Recu_PalabrasClave">
                                                                    <strong>Palabras clave complementarias</strong>
                                                                </label>
                                                                <div className="col-sm-12 tab-general-palabras">
                                                                    <TagInput
                                                                        name="Recu_PalabrasClave"
                                                                        id="Recu_PalabrasClave"
                                                                        onChange={(val) => this.changeTagInput('Recu_PalabrasClave', val)}
                                                                        placeholder="Ingrese palabras clave separadas por un espacio"
                                                                    />
                                                                </div>
                                                            </div>                                                            
                                                            <div className="form-group" style={{display:'none'}} >
                                                                <label htmlFor="listPartida"><strong>Producto asociado</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownList
                                                                        name="sProducto"
                                                                        id="sProducto"
                                                                        // valor={""}
                                                                        etiqueta={"Producto"}
                                                                        metodo="added"
                                                                        onChange={this.handleProductoChange}
                                                                        componente={"Productos"}
                                                                        isMulti={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="cEstado"><strong>Estado</strong></label>
                                                                  <span> [{this.state.resource.sEstado}] </span>
                                                            </div>
 
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="cEstado"><strong>Estado</strong></label>
                                                                <div className="">
                                                                    <DropDownList
                                                                        filtro={this.state.roles}
                                                                        valor={"R"}
                                                                        etiqueta={"BORRADOR"}
                                                                        metodo="added"
                                                                        name="cEstado"
                                                                        id="cEstado"
                                                                        onChange={this.handleInputChange}
                                                                        clave={this.state.resource.cEstado}
                                                                        componente={"Estado"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="bActivo">
                                                                    <strong>Activo</strong>
                                                                </label>
                                                                <div className="">
                                                                    <DropDownList
                                                                        valor={"true"}
                                                                        etiqueta={"ACTIVO"}
                                                                        metodo="added"
                                                                        name="bActivo"
                                                                        id="bActivo"
                                                                        onChange={this.handleInputChange}
                                                                        clave={this.state.resource.bActivo}
                                                                        componente={"Activo"}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="col-md-4 ocultar">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div id='tab1-portada' className="form-group">
                                                                    <label htmlFor="bPortada"><strong>Portada</strong></label>
                                                                    <div className="bPortada">
                                                                        <Checkbox  name="bPortada" id="bPortada" onChange={this.handleInputChange} value={this.state.resource.bPortada} placeholder="Cabecera" />
                                                                    </div>
                                                                </div>
                                                                <div id='tab1-noticia' className="form-group">
                                                                    <label htmlFor="bImportante"><strong>Noticia Banner</strong></label>
                                                                    <div className="bImportante">
                                                                        <Checkbox  name="bImportante" id="bImportante" onChange={this.handleInputChange} value={this.state.resource.bImportante} placeholder="Cabecera" />
                                                                    </div>
                                                                </div>

                                                                <div  id='tab1-notipush' className="form-group">
                                                                    <label htmlFor="recu_NotificarPorPush">
                                                                        <strong>Notificar por push</strong>
                                                                    </label>
                                                                    <div className="recu_NotificarPorPush">
                                                                        <Checkbox
                                                                            name="recu_NotificarPorPush"
                                                                            id="recu_NotificarPorPush"
                                                                            onChange={this.handleInputChange}
                                                                            placeholder="Notificar por push"
                                                                            checked={this.state.resource.recu_NotificarPorPush}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div  id='tab1-notimail' className="form-group">
                                                                    <label htmlFor="recu_NotificarPorCorreo">
                                                                        <strong>Notificar por correo</strong>
                                                                    </label>
                                                                    <div className="recu_NotificarPorCorreo">
                                                                        <Checkbox
                                                                            name="recu_NotificarPorCorreo"
                                                                            id="recu_NotificarPorCorreo"
                                                                            onChange={this.handleInputChange}
                                                                            placeholder="Notificar por push"
                                                                            checked={this.state.resource.recu_NotificarPorCorreo}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="sEnlaceInteres"><strong>Enlace a recursos externos</strong></label>
                                                                    <input type="text" name="sEnlaceInteres" id="sEnlaceInteres" onChange={this.handleInputChange} defaultValue={this.state.resource.sEnlaceInteres} className="form-control text-filter__form-control" placeholder="Enlace a recursos externos" />
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={1}>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="sArchivoNombre">
                                                                    <strong>Nombre Documento</strong>
                                                                </label>
                                                                <input type="text" name="sArchivoNombre"
                                                                  className="form-control text-filter__form-control"
                                                                  defaultValue={this.state.resource.sArchivoNombre }
                                                                  id="sArchivoNombre"
                                                                  onChange={this.handleInputChange}
                                                                //   onBlur={this.letrasNumeroBlur}
                                                                  style={{padding: "15px"}}
                                                                  placeholder="Nombre documento (sin extensión)" />
                                                            </div>
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <style>{`
                                                                  .doc-uploader-wrapper .errorMessage {
                                                                    font-size: 0 !important;
                                                                  }
                                                                  .doc-uploader-wrapper .errorMessage::before {
                                                                    content: "El archivo no cumple con el formato o parámetro permitido.";
                                                                    font-size: 12px;
                                                                    color: red;
                                                                  }
                                                                `}</style>
                                                                <br></br>
                                                                <div className="doc-uploader-wrapper">
                                                                <ImageUploader
                                                                  imgExtension={['pdf']}
                                                                  accept='.pdf'
                                                                  onChange={(file) => this.onDrop(file,"selectedFile")}
                                                                  buttonText='Elija un documento'
                                                                  label="Formato: PDF. Tamaño máximo: 40 MB."
                                                                  id="Uploader"
                                                                  singleImage={true}
                                                                  withIcon={false}
                                                                  withPreview={false} maxFileSize={41943040}
                                                                />
                                                                </div>
                                                                <PdfFirstPagePreview
                                                                  file={this.state.selectedFile || null}
                                                                  width={500}
                                                                  height={450}
                                                                />
                                                                <button
                                                                    disabled={!this.state.selectedFile}
                                                                    type="button"
                                                                    className="btn btn-primary btn-primary__tool"
                                                                    onClick={this.uploadFile}
                                                                >
                                                                    Subir el documento
                                                                </button>
                                                                &nbsp;&nbsp;
                                                                <button type="button" className="btn btn-primary btn-color-rojo-borde" onClick={this.unSelectDoc}>Eliminar el documento</button>
                                                                <br/>
                                                                <br/>
                                                                <div className="form-group">
                                                                    <strong>Enlace al documento: </strong>&nbsp;
                                                                    {
                                                                      !this.state.resource.sEnlaceDocumento
                                                                      ? ""
                                                                      : (
                                                                        <a id="span-sEnlaceDocumento" target='_blank' href={BASE_URL_RECURSOS+this.state.resource.sEnlaceDocumento}>
                                                                          {this.state.resource.sEnlaceDocumento}
                                                                        </a>
                                                                      )
                                                                    }
                                                                </div>    
                                                                  {/* <strong>Documento: </strong>&nbsp; {this.state.resource.sDescripcionLineaProducto} */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={2}>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <label><strong>Ingrese el resumen del documento</strong></label>
                                                                <CKEditor
                                                                    data={this.state.resource.recu_ResumenPdf}
                                                                    onChange={(e)=> this.onEditorChangeEditResumen(e, "recu_ResumenPdf")}
                                                                    config={currentCKEditorConfig}
                                                                    id="recu_ResumenPdf"
                                                                    name="recu_ResumenPdf"
                                                                />
                                                                <label htmlFor="recu_ResumenPdf-recu_ResumenPdf" style={{textAlign:'right', display:'block'}}><strong><span id='count-caracteres-recu_ResumenPdf'>0</span>/{LIMITE_CARACTERES_RESUMEN} caracteres</strong></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={3}>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="sTituloImagen"><strong>Título Imagen</strong></label>
                                                                <input type="text" name="sTituloImagen"
                                                                  className="form-control text-filter__form-control ocultar"
                                                                  defaultValue={this.state.resource.sTituloImagen||""}
                                                                  onChange={this.handleInputChange} id="sTituloImagen"
                                                                  style={{padding: "15px"}}
                                                                  placeholder="Título archivo" />
                                                            </div>

                                                            {/* <div className="boletin__filters section__margin-bottom">
                                                                <button
                                                                  type="button" className="btn btn-primary btn-primary__tool"
                                                                  data-toggle="modal" data-target="#thumbnail-modal">
                                                                    {this.state.resource.sImagen?"CAMBIAR":"SELECCIONAR DE SERVIDOR"}
                                                                </button>
                                                            </div> */}
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <style>{`
                                                                  .img-uploader-wrapper .errorsContainer::before {
                                                                    content: "";
                                                                  }
                                                                  .img-uploader-wrapper.hay-error-dimension .errorsContainer::before {
                                                                    content: "El archivo no cumple con el formato o parámetro permitido.";
                                                                    display: block;
                                                                    font-size: 12px;
                                                                    color: red;
                                                                    text-align: center;
                                                                  }
                                                                  .img-uploader-wrapper .errorMessage {
                                                                    font-size: 0 !important;
                                                                  }
                                                                  .img-uploader-wrapper .errorMessage::before {
                                                                    content: "El archivo no cumple con los formatos o parámetros permitidos.";
                                                                    font-size: 12px;
                                                                    color: red;
                                                                  }
                                                                `}</style>
                                                                <div
                                                                  className={"img-uploader-wrapper" + (this.state.imageDimensionError ? " hay-error-dimension" : "")}
                                                                  onClick={this.clearImageDimensionError}
                                                                >
                                                                <ImageUploader
                                                                  key={this.state.uploaderKey}
                                                                  imgExtension={['.jpg', '.gif', '.png', '.jpeg']}
                                                                  accept='.jpg,.jpeg,.gif,.png'
                                                                  onChange={(file) => this.onDrop(file,"selectedImage")}
                                                                  buttonText='Elija una imagen'
                                                                  label={`Formatos: JPG, JPEG, GIF o PNG. Dimensiones: ${this.state.imageLimitDimension ? `${this.state.imageLimitDimension.width}x${this.state.imageLimitDimension.height}` : '960x600'} píxeles. Tamaño máximo: 5 MB.`}
                                                                  id="Uploader"
                                                                  singleImage={true} withIcon={false}
                                                                  withPreview={true} maxFileSize={5242880}
                                                                />
                                                                </div>
                                                                <div className="mb-2">
                                                                    <span style={{fontSize:'11px'}}>IMPORTANTE: Verifique que la imagen que utilizará no infringe los derechos de autor de terceros y cuenta con todas las autorizaciones de uso.</span>
                                                                </div>
                                                                <div>
                                                                    <button
                                                                        disabled={!this.state.selectedImage}
                                                                        type="button"
                                                                        className="btn btn-primary btn-primary__tool"
                                                                        onClick={this.uploadImage}
                                                                    >
                                                                        Subir imagen
                                                                    </button>
                                                                    &nbsp;&nbsp;
                                                                    <button type="button" className="btn btn-primary btn-color-rojo-borde" onClick={this.unSelectImage}>Eliminar imagen</button>
                                                                </div> 
                                                                    <br/>
                                                                    <div className="form-group">
                                                                    <strong>Enlace a la imagen: </strong>&nbsp;
                                                                    {
                                                                      !this.state.resource.sImagen
                                                                      ? ""
                                                                      : (
                                                                        <a id="span-sEnlaceDocumento" target='_blank' href={BASE_URL_RECURSOS+this.state.resource.sImagen}>
                                                                          {this.state.resource.sImagen}
                                                                        </a>
                                                                      )
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 ocultar">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                {!this.state.resource.sImagen
                                                                  ? (<h6>:-(</h6>)
                                                                  : (
                                                                    <div>
                                                                      <img className="col-md-12"
                                                                        src={BASE_URL_RECURSOS + this.state.resource.sImagen} />
                                                                      <br/><br/>
                                                                      <button type="button" className="btn btn-primary btn-primary__tool" onClick={this.unSelectImage}>Eliminar imagen</button>
                                                                    </div>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={4}>
                                                    <div className="row xxxxx" style={{background:'white'}}>
                                                        <div className="col-md-4" >
                                                            <div className=" section__margin-top" style={{marginTop:'10px'}}>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoTitulo"><strong>Aprobador</strong></label>
                                                                </div>
                                                                <div className="form-group">
                                                                    <DropDownList
                                                                        valor={0}
                                                                        etiqueta={"APROBADOR"}
                                                                        metodo="added"
                                                                        name="nAprobador"
                                                                        id="nAprobador"
                                                                        onChange={this.handleInputChange}
                                                                        clave={this.state.resource.nAprobador}
                                                                        componente={"RES_CMS_APROBADOR"}
                                                                        placeholder="Seleccione un aprobador"
                                                                    />
                                                                </div>
                                                                <div className="form-group">
                                                                </div>
                                                                <div className="txtFile x-1 relative">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className=" section__margin-top" style={{marginTop:'50px'}}>
                                                                <div className="form-group">
                                                                    {/* <label htmlFor=""><strong>&nbsp;</strong></label> */}
                                                                    <div className=" botonera" >
                                                                        <BotoneraEstados parent={this}  momentoCrud={"insert"} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row" style={{display:'none'}} >
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoTitulo"><strong>SEO Título</strong></label>
                                                                    <input type="text" name="recu_SeoTitulo" id="recu_SeoTitulo" onChange={this.handleInputChange} maxLength={70} defaultValue={this.state.resource.recu_SeoTitulo} className="form-control text-filter__form-control" placeholder="SEO Título (70 caracteres)" />
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoDescripcion"><strong>SEO Descripción</strong></label>
                                                                    <textarea name="recu_SeoDescripcion" id="recu_SeoDescripcion" onChange={this.handleInputChange} maxLength={140} defaultValue={this.state.resource.recu_SeoDescripcion} className="form-control text-filter__form-control" placeholder="SEO Descripción (140 caracteres)" style={{height: "100px"}}></textarea>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoUrlCanonical"><strong>SEO Url Canonical</strong></label>
                                                                    <input type="text" name="recu_SeoUrlCanonical" id="recu_SeoUrlCanonical" onBlur={this.letrasCanonicalBlur} onChange={this.handleInputChange} maxLength={1000} defaultValue={this.state.resource.recu_SeoUrlCanonical} className="form-control text-filter__form-control" placeholder="SEO Url canonical" />
                                                                </div>
                                                                <div className="txtFile x-1 relative">
                                                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "recu_SeoImagen")}/>
                                                                    <input type="text" placeholder="SEO Imagen" name='recu_SeoImagen' value={this.state.resource.recu_SeoImagen} maxLength={1000} onChange={this.handleInputChange} className="form-control text-filter__form-control"/>
                                                                </div>
                                                            </div>
                                                            <ModalMultimedia class="divGestorArchivosMultimedia" callback={this.getResponse.bind(this)}/>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoSeguirEnlace">
                                                                        <strong>Seguir enlace</strong></label>
                                                                    <div className="recu_SeoSeguirEnlace">
                                                                        <Checkbox
                                                                            name="recu_SeoSeguirEnlace"
                                                                            id="recu_SeoSeguirEnlace"
                                                                            onChange={this.handleInputChange}
                                                                            //value={this.state.resource.recu_SeoSeguirEnlace}
                                                                            placeholder="Seguir enlace"
                                                                            checked={this.state.resource.recu_SeoSeguirEnlace}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoMostrarMotores">
                                                                        <strong>Mostrar motores</strong></label>
                                                                    <div className="recu_SeoMostrarMotores">
                                                                        <Checkbox
                                                                            name="recu_SeoMostrarMotores"
                                                                            id="recu_SeoMostrarMotores"
                                                                            onChange={this.handleInputChange}
                                                                            //value={this.state.resource.recu_SeoMostrarMotores}
                                                                            placeholder="Mostrar motores"
                                                                            checked={this.state.resource.recu_SeoMostrarMotores}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoScript"><strong>SEO Script</strong></label>
                                                                    <textarea name="recu_SeoScript" id="recu_SeoScript" onChange={this.handleInputChange} maxLength={1000} defaultValue={this.state.resource.recu_SeoScript} className="form-control text-filter__form-control" placeholder="Pegue aquí su código javascript" style={{height: "127px"}}></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </TabPanel>
                                            </div>
                                        </div>
                                        <div className="row botonera">
                                            <div className="col-md-12 d-flex justify-content-between align-items-center">
                                                <div style={{ minWidth: '120px' }}>
                                                {this.state.numeroTab > 0 && (
                                                    <button type="button" onClick={() => navegarTab(this,-1)} className="btn btn-danger btn-primary__submit btn-color-rojo-full">{"<< Anterior"}</button>
                                                )}
                                                </div>
                                                <div className="d-flex gap-2">
                                                     {/* <button type="button" onClick={(event) => this.handleClickCancel(event)} className="btn btn-default btn-primary__submit">Cancelar</button>
                                                     &nbsp;&nbsp; */}
                                                     <BotoneraCrud parent={this} modoCrud={"insert"} />
                                                </div>
                                                <div style={{ minWidth: '120px', textAlign: 'right' }}>
                                                    {this.state.numeroTab < 4 && (
                                                        <button type="button" onClick={() => navegarTab(this,1)} className="btn btn-success btn-primary__submit btn-color-verdefull">{"Siguiente >>"}</button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        </form>

                        {/* Modals */}
                        <div className="modal fade" id="thumbnail-modal" tabIndex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                          <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                              <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>

                              <div className="modal-body modal-subscription__body">
                                <p className="modal-subscription__title">Imagenes</p>

                                <p className="modal-subscription__info">
                                  <div className="recursos__wrapper-table">
                                    {/* Content */}
                                    {this.state.imagesToSelect
                                      ? <ThumbnailGrid
                                          selectImage={this.selectImage}
                                          img_links={this.state.imagesToSelect}
                                          changePage={this.getImages}
                                          sizeX={"150px"} sizeY={"150px"} />
                                      : <InComponentLoader show={true} message={"Se están obteniendo las imagenes, por favor espere un momento"} />
                                    }
                                  </div>
                                </p>
                                {this.paginationTable()}
                              </div>

                              <div className="modal-footer">
                                <button id="thumbnail-modal-close" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                  <i className="fas fa-close fa-sm"></i> &nbsp;
                                  <span>Cerrar</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                )
                :
                (
                    <Error StatusCode="500" StatusMessage="Error"></Error>
                )
                );
    }
}

// Wrapper funcional: permite usar el hook useUnsavedChanges y pasarlo como prop
// al formulario (que sigue siendo un componente de clase, sin tocar su lógica interna).
// NOTA: JSX distingue componentes de etiquetas HTML por la primera letra del nombre;
// como la clase se llama "add_recurso" (minúscula), no se puede usar directamente como
// <add_recurso .../> en JSX (React la trataría como una etiqueta HTML desconocida).
// Se usa React.createElement explícitamente para evitar ese problema sin renombrar la clase.
const AddRecursoWithGuard = (props) => {
    const { registerFormGuard, clearFormGuard, requestNavigation } = useUnsavedChanges();
    return React.createElement(add_recurso, { ...props, registerFormGuard, clearFormGuard, requestNavigation });
};

export default AddRecursoWithGuard;